import styled from "styled-components"

const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 6px 0;
`

export { OptionContainer as default }



// WEBPACK FOOTER //
// ./assets/interview/components/OptionContainer.js